import { INodePub, TORUS_SAPPHIRE_NETWORK, TORUS_SAPPHIRE_NETWORK_TYPE } from "@toruslabs/constants";

export const SAPPHIRE_NODE_PUB_KEYS: Record<TORUS_SAPPHIRE_NETWORK_TYPE, INodePub[]> = {
  [TORUS_SAPPHIRE_NETWORK.SAPPHIRE_MAINNET]: [
    {
      X: "e0925898fee0e9e941fdca7ee88deec99939ae9407e923535c4d4a3a3ff8b052",
      Y: "54b9fea924e3f3e40791f9987f4234ae4222412d65b74068032fa5d8b63375c1",
    },
    {
      X: "9124cf1e280aab32ba50dffd2de81cecabc13d82d2c1fe9de82f3b3523f9b637",
      Y: "fca939a1ceb42ce745c55b21ef094f543b457630cb63a94ef4f1afeee2b1f107",
    },
    {
      X: "555f681a63d469cc6c3a58a97e29ebd277425f0e6159708e7c7bf05f18f89476",
      Y: "606f2bcc0884fa5b64366fc3e8362e4939841b56acd60d5f4553cf36b891ac4e",
    },
    {
      X: "2b5f58d8e340f1ab922e89b3a69a68930edfe51364644a456335e179bc130128",
      Y: "4b4daa05939426e3cbe7d08f0e773d2bf36f64c00d04620ee6df2a7af4d2247",
    },
    {
      X: "3ecbb6a68afe72cf34ec6c0a12b5cb78a0d2e83ba402983b6adbc5f36219861a",
      Y: "dc1031c5cc8f0472bd521a62a64ebca9e163902c247bf05937daf4ae835091e4",
    },
  ],
  [TORUS_SAPPHIRE_NETWORK.SAPPHIRE_DEVNET]: [
    {
      X: "f74389b0a4c8d10d2a687ae575f69b20f412d41ab7f1fe6b358aa14871327247",
      Y: "54e3a73098ed9bced3ef8821736e9794f9264a1420c0c7ad15d2fa617ba35ef7",
    },
    {
      X: "bc38813a6873e526087918507c78fc3a61624670ee851ecfb4f3bef55d027b5a",
      Y: "ac4b21229f662a0aefdfdac21cf17c3261a392c74a8790db218b34e3e4c1d56a",
    },
    {
      X: "b56541684ea5fa40c8337b7688d502f0e9e092098962ad344c34e94f06d293fb",
      Y: "759a998cef79d389082f9a75061a29190eec0cac99b8c25ddcf6b58569dad55c",
    },
    {
      X: "7bcb058d4c6ffc6ba4bfdfd93d141af35a66338a62c7c27cdad2ae3f8289b767",
      Y: "336ab1935e41ed4719e162587f0ab55518db4207a1eb36cc72303f1b86689d2b",
    },
    {
      X: "bf12a136ef94399ea098f926f04e26a4ec4ac70f69cce274e8893704c4951773",
      Y: "bdd44828020f52ce510e026338216ada184a6867eb4e19fb4c2d495d4a7e15e4",
    },
  ],
};
